import { render } from "./CreateLearningGoalComponent.vue?vue&type=template&id=b007c3be&scoped=true"
import script from "./CreateLearningGoalComponent.vue?vue&type=script&lang=js"
export * from "./CreateLearningGoalComponent.vue?vue&type=script&lang=js"

import "./CreateLearningGoalComponent.vue?vue&type=style&index=0&id=b007c3be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b007c3be"]])

export default __exports__